import { makeStyles } from 'tss-react/mui';

import { Sign } from 'modules/common/types';

export const useProjectRequestsActivityStyles = makeStyles<{
  sign: Sign;
  isDisabled: boolean;
}>()((theme, { isDisabled, sign }) => {
  const colorMap = {
    0: theme.palette.text.secondary,
    1: theme.palette.success.main,
    [-1]: theme.palette.purple.main,
  };

  const color = isDisabled ? theme.palette.text.secondary : colorMap[sign];

  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    text: {
      color: theme.palette.grey[600],
    },
    count: {
      fontWeight: 400,
      lineHeight: '140%',
    },
    percent: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      paddingLeft: theme.spacing(1),

      color,

      fontWeight: 400,
      lineHeight: '140%',
    },
    icon: {
      color,

      fontSize: 14,
    },
  };
});
